module.exports = __webpack_public_path__ + "img/userLogo11.dbb3aba3.jpg";